import { connect } from 'react-redux';

import {
  getPropertiesForValuationChart,
  getChartDataSelectedValuationChartType
} from 'selectors/chart-data';
import { getAvmWithFallback, getAvmSelectedKey } from 'selectors/avms';
import { getReportStatusNearbyPropertiesIsLoadingInitial } from 'selectors/report-status';
import { getSubjectDefault } from 'selectors/subject';

import PropertyExplorerValuationChart from 'legacy/components/PropertyExplorerValuationChart';
import { getIsEffectiveDateReport } from '../appstore/selectors/property-explorer.selectors';

const mapStateToProps = (state) => {
  const subjectDefault = getSubjectDefault(state);
  const isEffectiveDateReport = getIsEffectiveDateReport(state);
  return {
    chartType: getChartDataSelectedValuationChartType(state),
    isLoading: getReportStatusNearbyPropertiesIsLoadingInitial(state),
    comps: getPropertiesForValuationChart(state),
    avmKey: getAvmSelectedKey(state),
    avm: getAvmWithFallback(state),
    priceKey: isEffectiveDateReport ? 'salesPrice' : 'salesPriceAdjusted',
    isInNonDisclosureState: subjectDefault.isInNonDisclosureState
  };
};

export default connect(mapStateToProps)(PropertyExplorerValuationChart);
